/** personal info modal */
export class PersonalInfo {
	/** holds HA ID */
	healthAssessmentID: number;
	/** holds address modal */
	address: Address;
	/** holds preferred email */
	preferredEmail: string;
	/** holds home phone value */
	homePhone: string;
	/** holds cell phone value */
	cellPhone: string;
	/** holds place of birth */
	placeOfBirth: string;
	/** holds ethnic background info */
	ethnicBackgroundID: number;
	/** holds marital status info */
	maritalStatusID: number;
	/** holds education level info */
	educationID: number;
}

/** address info modal */
export class Address {
	/** holds address line 1 */
	addressLine1: string;
	/** holds address line 2 */
	addressLine2: string;
	/** holds city details */
	city: string;
	/** holds state details */
	state: string;
	/** holds zip details */
	zip: string;
	/** holds country details */
	country: string;
}

/** emergency contact info modal */
export class EmergencyContact {
	/** holds HA ID */
	healthAssessmentID: number;
	/** holds full name  value */
	fullName: string;
	/** holds phone value */
	phone: string;
	/** holds relationship value */
	relationship: string;
}

/** living will modal */
export class LivingWill {
	/** holds HA ID */
	healthAssessmentID: number;
	/** holds living will option */
	haveLivingWill: boolean;
	/** holds the option whether patient needs to discuss or not */
	discussOption: boolean;
}

/** primary care physician object */
export class PrimaryCarePhysician {
	/** holds HA ID */
	healthAssessmentID: number;
	/** holds flag related to primary care physician */
	havePrimaryCarePhysician: boolean;
	/** holds full name value */
	fullName: string;
	/** holds phone number */
	phone: string;
	/** holds fax details */
	fax: string;
}

/** specialists object */
export class Specialists {
	/** holds HA ID */
	healthAssessmentID: number;
	/** holds see medical specialist flag */
	seeMedicalSpecialist: boolean;
	/** holds specialist list */
	specialists: SpecialistObject[];
}

/** specialist object */
export class SpecialistObject {
	/** holds full name value */
	fullName: string;
	/** holds speciality value */
	specialty: string;
	/** holds phone number */
	phone: string;
}
